import _ from 'lodash'
import SelectScorecardForm from '../common/select-scorecard-form'

var SelectScorecardStep = SelectScorecardForm.extend({

	initialize: function(options) {
		if (this.model && !this.model.has('filters')) {
			this.model.set('filters', {scorecardNodeIds: []})
		}
		//#16410 do not use actual filter object, otherwise the id will be set which is not what we want
		let data = _.assign({}, _.get(this.model.attributes, 'filters.scorecardNodeIds[0]', {}))
		data.id = _.get(data, 'ancestorValues[0]', null)
		data.linkGroup = _.get(data, 'linkGroup', 0)

		var opts = options || {}
		opts.data = data

		SelectScorecardForm.prototype.initialize.call(this, opts)

		this.listenTo(this, 'item', (item) => {
			//#19305 ensure the org tree is fully loaded before capturing the item data for org info
			this.objectSelector.orgGardener._onceTreeLoaded(() => {
				let f = this.model.get('filters')
				if (!item) {
					delete f.scorecardNodeIds
				} else {
					let obj = {ancestorValues: [item.id], metadata:{}, linkGroup: item.linkGroup}
					let org = this.objectSelector.orgGardener.tree.get(item.organizationId)
					obj.metadata[item.id] = {label: item.label, orgLabel: org.label}
					f.scorecardNodeIds = [obj]
				}
				this.model.trigger('change')
			})
		})

		this.listenTo(this, 'followLinked', function (followLinked) {
			_.assign(this.model.get('filters').scorecardNodeIds[0], {followLinked: followLinked})
			this.model.trigger('change')
		}.bind(this))
	}

})

export default SelectScorecardStep

SelectScorecardStep.__filename__ = 'reports/wizard/common/select-ancestor-scorecard-step.js'
